import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {DeviceDetectorService} from 'ngx-device-detector';
import {Meta, Title} from '@angular/platform-browser';
import { FormsUtils } from '../../../utils/FormUtils';

declare var hbspt: any;

@Component({
    selector: 'app-soporte',
    templateUrl: './soporte.component.html',
    styleUrls: ['./soporte.component.scss']
})
export class SoporteComponent implements OnInit {
    tam: number;
    num: number;
    @ViewChild('main')
    main: ElementRef;
    /* VARIABLES PARA SABER SI SON MOVILES */
    isMobile: any = false;
    isTablet: any = false;
    idForm: string;

    constructor(
        private deviceService: DeviceDetectorService,
        private metas: Meta,
        private titlePage: Title,
        private _formsUtils: FormsUtils
    ) {
        this.isMobile = this.deviceService.isMobile();
        this.isTablet = this.deviceService.isTablet();
        const TITLE = 'Precisa de ajuda para começar a assinar com o FAD® | A única Assinatura Autógrafa Digital®';
        const DESCRIPTION = 'Consulte com um de nossos executivos o pacote ou assinatura que melhor se adapta às suas necessidades, entre em contato pelo telefone +52 (55) 2665 9500';
        const URL = 'https://www.assinaturaautografadigital.com.br/como-comecar-a-assinar-digitalmente';
        const IMG = 'https://hola.firmaautografa.com/hubfs/BRASIL-ASSETS/METAS-PLACE-BRASIL-PAGES/soporte.png';
        this.titlePage.setTitle(TITLE);
        /* PRINCIPALES */
        this.metas.updateTag({
            name: 'keywords',
            content: 'como conseguir una firma digital, como obtener firma digital'
        });
        this.metas.updateTag({
            name: 'description',
            content: DESCRIPTION
        });
        /* FACEBOOK Y LINKEDIN */
        this.metas.updateTag({
            property: 'og:url',
            content: URL
        });
        this.metas.updateTag({
            property: 'og:title',
            content: TITLE
        });
        this.metas.updateTag({
            property: 'og:description',
            content: DESCRIPTION
        });
        this.metas.updateTag({
            property: 'og:image',
            content: IMG
        });
        /* TWITTER */
        this.metas.updateTag({
            name: 'twitter:title',
            content: TITLE
        });
        this.metas.updateTag({
            name: 'twitter:description',
            content: DESCRIPTION
        });
        this.metas.updateTag({
            name: 'twitter:image',
            content: IMG
        });
        window.scrollTo(0, 0);
        this.num = 0;
    }

    ngOnInit(): void {
        // if (this.isMobile === true || this.isTablet === true) {
        //     hbspt.forms.create({
        //         region: 'na1',
        //         portalId: '5707307',
        //         formId: '9f6fd424-5978-4fd3-ae28-7381b49c1c9f',
        //         target: '#form-support-movil'
        //     });
        // } else if (this.isMobile === false && this.isTablet === false) {
        //     hbspt.forms.create({
        //         region: 'na1',
        //         portalId: '5707307',
        //         formId: '9f6fd424-5978-4fd3-ae28-7381b49c1c9f',
        //         target: '#form-support'
        //     });
        // }

        this.idForm = this._formsUtils.getFormIdByLang();
        this._formsUtils.buildSovosForm();
    }

}
